import React from 'react';
import cn from 'classnames';
import styles from './styles.scss';

const Switch = ({ onChange, value, options }) => <div className={styles.Container}>
  {Object.keys(options).map(key => {
    const isSelected = value == key;

    return (
      <div
        onClick={() => onChange(key)}
        key={key + options[key]}
        className={cn({ [styles.Selected]: isSelected })}
      >
        {options[key]}
        {isSelected && <div className={styles.SelectedBlock}></div>}
      </div>
    );
  })}
</div>;

export default React.memo(Switch);



// WEBPACK FOOTER //
// ./src/containers/Rates/Switch/index.js